module.exports = __webpack_public_path__ + "img/PEYTO_I.75265412.png";